import { getAllLayers } from 'pxc-editor-core/helpers/schema';

export default ({ sectionsSelection, pages }) => {
  let selectedSection = null;

  for (const secId in sectionsSelection) {
    const { section } = getAllLayers(secId, pages);
    selectedSection = section;
    break;
  }

  return selectedSection;
};
